import { useI18next, useTranslation } from 'gatsby-plugin-react-i18next';

export const Pricing = () => {
  const { t } = useTranslation();
  const { path } = useI18next();

  const isUsPage = path.startsWith('/us/');
  const isWebVisitorsPage =
    path.includes('/solutions/web-visitor-tracking/') ||
    path.includes('/web-visitors/');

  return {
    label: t('nav_pricing_page'),
    href: isUsPage
      ? '/us/pricing'
      : isWebVisitorsPage
      ? '/pricing-web-visitors'
      : '/pricing',
  };
};
